import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";

export const settingSetQueryKey = (settingKey: string) => ["settingSet", settingKey] as const;

// Presence-only read for a customer setting. Does not return the value, so it is safe for
// settings that are not visible to the customer (API keys, secrets).
export default function useSettingSet(settingKey: string, loading: boolean = false) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60 * 60 * 1;

  const settingSet = useQuery({
    queryKey: settingSetQueryKey(settingKey),
    queryFn: () => get<DefaultResponseWithData<boolean>>(`/setting/${settingKey}/set`),
    enabled: !loading,
    staleTime,
    cacheTime: staleTime,
    refetchOnWindowFocus: false,
  });

  return {
    settingSet,
    isSet: !!settingSet.data?.data,
    isLoading: settingSet.isLoading,
  };
}
